import React from 'react'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import Sheet from 'components/utils/Sheet'
import LoyaltyTierPill from 'components/Luxkit/LoyaltyTierPill'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'

const TriplePointSheet = styled(Sheet)`
 &.bronze {
    background: linear-gradient(63deg, ${props => props.theme.palette.product.loyalty.bronze.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.bronze.normalBackground} 83.34%);
  }

  &.silver {
    background: linear-gradient(63deg, ${props => props.theme.palette.product.loyalty.silver.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.silver.normalBackground} 83.34%);
  }

  &.gold {
    background: linear-gradient(63deg, ${props => props.theme.palette.product.loyalty.gold.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.gold.normalBackground} 83.34%);
  }

  &.platinum {
    background: linear-gradient(63deg, ${props => props.theme.palette.product.loyalty.platinum.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.platinum.normalBackground} 83.34%);
  }
`

function TriplePointTakeoverSearchTileBanner() {
  const [tier] = useCurrentLoyaltyTier()
  return <TriplePointSheet
    background={`tier-${tier}-primary`}
    className={tier}
    padding={8}
    tabletPadding="12 16"
  >
    <Group direction="horizontal" gap={16} verticalAlign="center">
      <LoyaltyTierPill tier={tier} variant="primary">Triple points</LoyaltyTierPill>
      <BodyText variant="medium" weight="bold">
        Limited-time offer on select packages
      </BodyText>
    </Group>
  </TriplePointSheet>
}

export default TriplePointTakeoverSearchTileBanner
